import classNames from 'clsx';
import React from 'react';

import styles from './UIStateSwitch.scss';

interface Props {
  active: string;
  className?: string;
  onChange: (id: string) => void;
  states: {
    name: string;
    id: string;
    icon: React.FC<React.SVGAttributes<SVGElement>>;
  }[];
}

const UIStateSwitch: React.FC<Props> = ({ states, active, onChange, className }) => (
  <div className={classNames(styles.container, className)}>
    {states.map(({ name, icon, id }) => (
      <div
        title={name}
        onClick={() => onChange(id)}
        key={id}
        className={classNames(styles.item, { [styles.active]: active === id })}
      >
        {React.createElement(icon)}
      </div>
    ))}
  </div>
);
export default UIStateSwitch;
